import React, { Component } from 'react';
import { withAsyncActions } from 'react-async-client';
import { Field } from 'react-final-form';
import Select from 'components/common/form/Select';
import Translate from 'react-translate-component';

import { getReplacing } from 'actions/asyncActions';
import { fullAutoOptions } from 'constants/asyncClient';
import { required } from 'utils/validators';

@withAsyncActions({
    getReplacing: getReplacing
        .withPayload(({ organizationId, departmentId }) => ({
            organizationId,
            departmentId
        }))
        .withOptions(fullAutoOptions)
})
export default class ReplacingField extends Component {
    render() {
        const { getReplacing, getReplacing: { data: replacing } } = this.props;

        return (
            <Field
                dictionaryAction={getReplacing}
                name='replacing'
                allowClear
                showSearch
                component={Select}
                options={replacing}
                namePath='firstName'
                label={{ content: 'request.replacing' }}
                placeholder={<Translate content='placeholders.chooseEmployee' />}
                validate={required}
            />
        );
    }
}
